import { render, staticRenderFns } from "./cTasks.vue?vue&type=template&id=84ccf6de&scoped=true"
import script from "./cTasks.vue?vue&type=script&lang=js"
export * from "./cTasks.vue?vue&type=script&lang=js"
import style0 from "./cTasks.vue?vue&type=style&index=0&id=84ccf6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ccf6de",
  null
  
)

export default component.exports